import React, {useEffect, useState} from 'react'
import {Route, Switch, Redirect} from 'react-router-dom';
import './App.css';

import Session from './components/Session/Session';
import Stream from './components/Stream/Stream';

function App() {

    return (
        <>
            <Switch>
                <Route path='/' exact component={() => <Redirect to='/p'/>}/>

                <Route path='/p/:roomId?' component={Session} exact/>

                <Route path='/c/:roomId?' component={Session} exact/>
                <Route path='/s/:id' component={Stream} exact/>
            </Switch>
        </>
    );
}

export default App;
